/* Customer reviews ticker + mobile slider */
(function () {
  'use strict';

  function initTicker(root) {
    if (!root) return;
    const track = root.querySelector('.reviews__track');
    if (!track) return;

    // Desktop ticker only
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      initMobileSlider(root, track);
      return;
    }

    // ----- Desktop vertical ticker -----
    if (!track.hasAttribute('data-cloned')) {
      const originalContent = track.innerHTML;
      track.innerHTML = originalContent + originalContent;
      track.setAttribute('data-cloned', 'true');
      track.offsetHeight;
    }

    const speed = Number(root.getAttribute('data-speed')) || 1000;
    const distancePx = track.scrollHeight / 2;
    const duration = distancePx / speed;
    track.style.setProperty('--desktop-duration', duration + 's');
  }

  function initMobileSlider(root, track) {
    const slides = track.children;
    if (!slides.length) return;

    // Use Flickity for mobile swipe functionality
    if (window.theme && window.theme.Flickity) {
      // Remove existing controls if any
      const existingControls = root.querySelector('.slider-controls');
      if (existingControls) {
        existingControls.remove();
      }

      // Stop CSS animation
      track.style.animation = 'none';
      track.style.transform = 'none';

      // Initialize Flickity directly on the track element
      // The track already contains the slides as direct children
      const flkty = new window.theme.Flickity(track, {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        touchVerticalScroll: false,
        imagesLoaded: true,
        groupCells: false
      });

      // Handle resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.matchMedia('(max-width: 749px)').matches && flkty) {
            flkty.resize();
          }
        }, 250);
      });
    } else {
      // Fallback to original slider if Flickity is not available
      let currentIndex = 0;

      // Create navigation buttons
      let controls = root.querySelector('.slider-controls');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'slider-controls';
        controls.innerHTML = `
          <button class="prev">&#10094;</button>
          <button class="next">&#10095;</button>
        `;
        root.appendChild(controls);
      }

      const prevBtn = controls.querySelector('.prev');
      const nextBtn = controls.querySelector('.next');

      function updateSlide() {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }

      nextBtn.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % slides.length;
        updateSlide();
      });

      prevBtn.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        updateSlide();
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-reviews-ticker]').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    initAll(e.target);
  });
})();
